import PageWrapper from "../components/ui/PageWrapper";
import InteractiveMap from "../components/world/InteractiveMap";
import { motion } from "framer-motion";

export default function AroundTheWorldPage() {
  return (
    <PageWrapper className="pt-28 pb-20 bg-terminal">
      <div className="max-w-6xl mx-auto px-6">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl md:text-4xl font-bold text-brightText mb-4"
        >
          Around the World
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-dimText mb-12 max-w-2xl"
        >
          As a Minerva University student, I've lived and studied in four
          countries across four continents. Click on a pin to learn more about
          each location.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
          className="bg-terminalLight rounded-2xl border border-terminalBorder overflow-hidden"
        >
          <InteractiveMap />
        </motion.div>
      </div>
    </PageWrapper>
  );
}
